<template>
  <div>
    <!-- <Header /> -->
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex flex-col lg:flex-row">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-3 p-5">
          <!-- Search Bar -->

          <div class="flex flex-wrap gap-3 justify-end">
            <div class="relative w-full max-w-80">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="searchvalue"
                @input="fetchBlogs(1)"
                placeholder="Search..."
                class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                v-if="searchvalue"
                @click="clearSearch"
                class="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <button
              @click="this.blogPopup = true"
              class="bg-blues hover:bg-[#18469d] hover:text-white text-white rounded-lg text-xs font-semibold px-3 py-1"
            >
              Add Blog
            </button>
          </div>

          <!-- Table -->
          <div v-if="this.bloglist.length > 0">
            <div
              class="overflow-x-auto shadow-md rounded-lg border border-gray-200 bg-white"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-gray-50">
                  <tr class="border-b border-gray-200 whitespace-nowrap">
                    <th
                      class="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider border-r border-gray-200"
                    >
                      S NO
                    </th>
                    <th
                      class="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider border-r border-gray-200"
                    >
                      Created User
                    </th>
                    <th
                      class="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider border-r border-gray-200"
                    >
                      Blog Title
                    </th>

                    <th
                      class="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider border-r border-gray-200"
                    >
                      Created Date
                    </th>
                    <th
                      class="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                    >
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody
                  v-if="bloglist.length > 0"
                  class="divide-y divide-gray-200"
                >
                  <tr
                    v-for="(blog, index) in bloglist"
                    :key="blog.id"
                    class="hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200"
                  >
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200"
                    >
                      {{ (currentPage - 1) * pageSize + index + 1 }}
                    </td>
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm border-r border-gray-200"
                    >
                      <router-link
                        v-if="blog.bolger_id?.display_name"
                        :to="{
                          name: 'InstructorBlogDetails',
                          params: { blog_id: blog.id },
                        }"
                        class="text-blue-600 hover:text-blue-800 hover:underline"
                      >
                        <div class="flex items-start gap-3">
                          <div class="flex-shrink-0">
                            <div
                              class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center"
                            >
                              <span
                                class="text-blue-600 text-xs font-medium leading-none"
                              >
                                {{
                                  (
                                    blog?.bolger_id.display_name
                                      ?.trim()
                                      ?.charAt(0) || "N"
                                  ).toUpperCase()
                                }}
                              </span>
                            </div>
                          </div>

                          <div class="flex flex-col min-w-0 flex-1">
                            <div
                              class="font-medium text-blue-600 text-xs truncate uppercase leading-tight"
                              :title="blog?.bolger_id.display_name || 'NA'"
                            >
                              {{ blog?.bolger_id.display_name?.trim() || "NA" }}
                            </div>

                            <div
                              class="flex items-center gap-1 text-xs text-slate-400 mt-1 min-w-0"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-3 w-3 flex-shrink-0"
                                viewBox="0 -960 960 960"
                                fill="currentColor"
                              >
                                <path
                                  d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200Z"
                                />
                              </svg>

                              <span
                                class="truncate block"
                                :title="blog?.bolger_id?.email || 'NA'"
                              >
                                {{ blog?.bolger_id?.email?.trim() || "NA" }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </router-link>
                      <span v-else class="text-gray-400">NA</span>
                    </td>
                    <td class="px-6 py-4 text-sm border-r border-gray-200">
                      <router-link
                        v-if="blog.title"
                        :to="{
                          name: 'InstructorBlogDetails',
                          params: { blog_id: blog.id },
                        }"
                        class="text-blue-600 hover:text-blue-800 hover:underline line-clamp-2 max-w-md block"
                        :title="blog.title"
                      >
                        {{ truncate(blog.title, 150) }}
                      </router-link>
                      <span v-else class="text-gray-400">NA</span>
                    </td>

                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-600 border-r border-gray-200"
                    >
                      <span v-if="blog.create_date" class="flex items-center">
                        <svg
                          class="w-4 h-4 mr-1 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          ></path>
                        </svg>
                        {{ formatDate(blog.create_date) }}
                      </span>
                      <span v-else class="text-gray-400">NA</span>
                    </td>
                    <td class="px-6 py-4 text-sm border-r border-gray-200">
                      <!-- <router-link
                      :to="{
                        name: 'InstructorBlogsEdit',
                        params: { blog_id: blog.id },
                      }"
                      class="text-sm px-3 py-1 text-white font-bold rounded-md"
                    >
                      <img
                        src="@/assets/new/medit.png"
                        alt=""
                        srcset=""
                        class="w-6 h-6 bg-[#EDF8FF] hover:bg-green-200 p-1"
                      />
                    </router-link> -->
                      <button
                        @click="handleEditNavigation(blog)"
                        class="bg-gray-100 hover:bg-gray-200 text-white text-xs p-2 rounded-lg flex items-center justify-center transition-colors"
                        title="Edit blog"
                      >
                        <svg
                          class="w-4 h-4 text-gray-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>

                <tbody v-else>
                  <tr>
                    <td
                      colspan="5"
                      class="px-6 py-12 text-center border-t border-gray-200"
                    >
                      <div
                        class="flex flex-col items-center justify-center text-gray-400"
                      >
                        <svg
                          class="w-12 h-12 mb-3"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          ></path>
                        </svg>
                        <p class="text-lg">No Data Found</p>
                        <p class="text-sm">
                          No blog posts have been created yet
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
            >
              <!-- PAGE SIZE -->
              <div
                class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
              >
                <span class="flex md:hidden">Rows per page:</span>
                <select
                  v-model="pageSize"
                  @change="onPageSizeChange"
                  class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>

              <!-- PAGINATION -->
              <div v-if="totalPages > 1" class="flex justify-center">
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="fetchBlogs"
                />
              </div>
            </div>
          </div>
          <div
            v-else
            class="flex flex-col items-center justify-center text-gray-400"
          >
            <svg
              class="w-12 h-12 mb-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              ></path>
            </svg>
            <p class="text-lg">No Data Found</p>
            <p class="text-sm">No blog posts have been created yet</p>
          </div>
        </div>
      </div>

      <!-- Add popup -->
      <div
        v-if="this.blogPopup"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
      >
        <div
          class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-bold text-blues">Add Blog</h3>
            <img
              src="@/assets/newd/close.png"
              class="cursor-pointer"
              alt=""
              @click="this.blogPopup = false"
            />
          </div>

          <div class="w-full mt-2 flex flex-col relative rounded-2xl">
            <div class="w-full">
              <form
                ref="blogRef"
                class="overflow-y-auto"
                @submit.prevent="createBlogs"
              >
                <div class="py-2 flex flex-col gap-6">
                  <div
                    class="flex flex-col sm:flex-row items-center gap-4 w-full"
                  >
                    <div class="flex flex-col gap-2 w-full sm:w-1/2">
                      <label for="title" class="text-sm"
                        >Title <span class="text-red-400">*</span></label
                      >
                      <input
                        id="title"
                        type="text"
                        required
                        class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      />
                    </div>

                    <div class="flex flex-col gap-2 w-full sm:w-1/2">
                      <label
                        for="category"
                        class="flex gap-2 items-center text-sm"
                      >
                        Category <span class="text-red-400">*</span>
                        <svg
                          @click="is_CategoryPopup = true"
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-5 h-5 cursor-pointer"
                          viewBox="0 0 48 48"
                        >
                          <path
                            fill="#4caf50"
                            d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                          ></path>
                          <path fill="#fff" d="M21,14h6v20h-6V14z"></path>
                          <path fill="#fff" d="M14,21h20v6H14V21z"></path>
                        </svg>
                      </label>
                      <select
                        id="category"
                        required
                        class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      >
                        <option
                          v-for="category in categories"
                          :key="category.id"
                          :value="category.id"
                        >
                          {{ category.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="flex flex-col gap-2 w-full">
                    <label for="thumbnail" class="text-sm"
                      >Thumbnail <span class="text-red-400">*</span></label
                    >
                    <input
                      id="thumbnail"
                      type="file"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  <div class="flex flex-col gap-2 w-full">
                    <label for="description" class="text-sm"
                      >Description <span class="text-red-400">*</span></label
                    >
                    <QuillEditor
                      style="height: 130px"
                      theme="snow"
                      toolbar="full"
                      :content="description"
                      contentType="html"
                    />
                  </div>

                  <div class="flex items-center gap-2">
                    <input type="checkbox" id="Published" class="w-4 h-4" />
                    <label for="Published" class="text-sm">Published</label>
                  </div>

                  <div class="flex justify-end">
                    <div class="flex gap-3 flex-wrap items-center">
                      <button
                        type="submit"
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-blue-600 cursor-pointer text-white border-none '
                        "
                        class="border rounded-lg text-sm font-semibold px-5 py-1.5"
                      >
                        Save
                      </button>

                      <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Category Add in Course  -->
      <div
        v-if="is_CategoryPopup"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      >
        <div
          class="w-11/12 sm:w-2/3 lg:w-1/3 bg-white rounded-lg shadow-lg py-6 sm:py-10 px-6 sm:px-8 relative"
        >
          <!-- Close Button -->
          <div
            @click="is_CategoryPopup = false"
            class="absolute right-4 top-4 cursor-pointer flex items-center"
          >
            <span
              class="text-gray-700 hover:text-red-500 text-sm sm:text-base"
            ></span>
            <img
              class="h-8 w-8 sm:h-6 sm:w-6 ml-2"
              src="@/assets/closebutton.svg"
              alt="Close"
            />
          </div>

          <h4
            class="text-gray-700 text-center text-lg sm:text-xl font-semibold mt-6"
          >
            Add Category
          </h4>

          <form class="w-full mx-auto mt-6" @submit.prevent="categoryAdd">
            <div class="flex flex-col gap-4">
              <div>
                <label
                  for="categorytitle"
                  class="text-sm sm:text-base font-medium"
                >
                  Title <span class="text-red-400">*</span>
                </label>
                <input
                  id="categorytitle"
                  type="text"
                  required
                  class="w-full p-3 border border-gray-300 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <!-- Submit Button -->
              <div class="flex justify-end gap-3 items-center">
                <button
                  type="submit"
                  :disabled="categorySubmitting == true"
                  :class="
                    this.categorySubmitting == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                  "
                  class="rounded-lg text-sm px-6 py-2"
                >
                  Add Category
                </button>
                <img
                  v-if="categorySubmitting"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- edit popup -->
      <div
        v-if="this.editblogPopup"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
      >
        <div
          class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-bold text-blues">Edit Blog</h3>
            <img
              src="@/assets/newd/close.png"
              class="cursor-pointer"
              alt=""
              @click="this.editblogPopup = false"
            />
          </div>

          <div class="w-full mt-2 flex flex-col relative rounded-2xl">
            <div class="w-full">
              <form
                ref="blogRef"
                class="overflow-y-auto"
                @submit.prevent="updateDetails"
              >
                <div class="py-10 flex flex-col gap-10">
                  <div
                    class="flex flex-col lg:flex-row items-center gap-5 w-full"
                  >
                    <div class="flex flex-col gap-3 w-full">
                      <label for="title" class="text-sm" style="">
                        Title
                        <span class="text-red-400">*</span>
                      </label>
                      <input
                        id="title"
                        type="text"
                        v-model="blogeditlist.title"
                        required
                        class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      />
                    </div>
                    <div class="flex flex-col gap-3 w-full">
                      <label for="category" class="flex gap-2 items-center">
                        <div>
                          Category
                          <span class="text-red-400">*</span>
                        </div>

                        <svg
                          @click="is_CategoryPopup = true"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          class="w-5 h-5 cursor-pointer hidden"
                          viewBox="0 0 48 48"
                        >
                          <path
                            fill="#4caf50"
                            d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                          ></path>
                          <path fill="#fff" d="M21,14h6v20h-6V14z"></path>
                          <path fill="#fff" d="M14,21h20v6H14V21z"></path>
                        </svg>
                      </label>

                      <select
                        name="category"
                        required
                        class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                        id="category"
                      >
                        <option
                          v-for="category in categories"
                          :key="category"
                          :value="category.id"
                        >
                          {{ category.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="flex flex-col gap-3 w-full">
                    <label for="title" class="text-sm" style="">
                      Thumbnail
                      <span class="text-red-400">*</span>
                    </label>
                    <img
                      v-if="blogeditlist.thumbnail"
                      :src="blogeditlist.thumbnail"
                      class="w-[150px] h-[100px] rounded-lg"
                      alt=""
                    />
                    <input
                      id="thumbnail"
                      type="file"
                      @change="handleFileUpload"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <div class="flex flex-col gap-3 w-full">
                    <label for="title" class="text-sm" style="">
                      Description
                      <span class="text-red-400">*</span>
                    </label>
                    <QuillEditor
                      style="height: 300px"
                      theme="snow"
                      class="border rounded-2xl"
                      toolbar="full"
                      :content="blogeditlist.content"
                      @update:content="blogeditlist.content = $event"
                      contentType="html"
                    />
                  </div>

                  <div class="flex items-center gap-2 py-10">
                    <input
                      type="checkbox"
                      id="Published"
                      v-model="blogeditlist.published"
                    />
                    <label for="checkbox" class="text-sm">Published</label>
                  </div>
                  <div class="flex justify-end">
                    <div class="flex gap-3 items-center">
                      <button
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-blue-600 cursor-pointer text-white border-none'
                        "
                        type="submit"
                        class="border rounded-lg text-sm font-semibold px-5 py-1.5"
                      >
                        Save
                      </button>

                      <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import SideBar from "@/components/Admin/SideBar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    QuillEditor,
  },
  data() {
    return {
      searchvalue: "",
      currentPage: 1,
      totalPages: 1,
      bloglist: [],
      blogPopup: false,
      editblogPopup: false,
      disable_submit: false,
      categorySubmitting: false,
      is_CategoryPopup: false,
      categories: null,
      messages: {
        text: "",
        type: "null",
      },
      blogeditlist: [],
      pageSize: 10,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.fetchBlogs(1);
    this.categoryget();
  },
  methods: {
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.fetchBlogs(1);
    },
    truncate(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    },
    handleEditNavigation(blog) {
      this.blogeditlist = blog;
      this.editblogPopup = true;
    },
    async updateDetails(e) {
      this.disable_submit = true;
      //   this.description = document.querySelector(".ql-editor").innerHTML;

      //   let thumbnailVal = null;
      //   if (e.target.elements.thumbnail.files.length > 0) {
      //     thumbnailVal = e.target.elements.thumbnail.files[0];
      //   }
      //   let updatedBlogInfo = {
      //     title: e.target.elements.title.value,
      //     published: e.target.elements.Published.checked,
      //     content: this.description,
      //     category_id: parseInt(e.target.elements.category.value),
      //     bolger_id: this.userInfo.user.id,
      //     thumbnail: this.thumbnailVal,
      //   };
      this.description = document.querySelector(".ql-editor").innerHTML;

      let updatedBlogInfo = new FormData();
      updatedBlogInfo.append("title", e.target.elements.title.value);
      updatedBlogInfo.append("published", e.target.elements.Published.checked);
      updatedBlogInfo.append("content", this.description);
      updatedBlogInfo.append(
        "category_id",
        parseInt(e.target.elements.category.value),
      );
      updatedBlogInfo.append("bolger_id", this.userInfo.user.id);

      if (this.thumbnailFile) {
        updatedBlogInfo.append("thumbnail", this.thumbnailFile);
      }

      await axios
        .patch(
          `${process.env.VUE_APP_API}/blog-details/deleted/${this.blogeditlist.id}/?Key=${this.userInfo.token_key}`,
          updatedBlogInfo,
        )
        .then((response) => {
          this.res = response;

          if (this.res.data.status == 200) {
            this.messages = {
              text: "Blogs Updated successfully",
              type: "success",
            };
            console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        // this.$router.push({
        //   name: "InstructorBlogsList",
        // });
        this.editblogPopup = false;
        this.disable_submit = false;
      }, 2500);
    },
    clearSearch() {
      this.searchvalue = "";
      this.fetchBlogs(1);
    },
    formatDate(date) {
      return new Date(date).toISOString().split("T")[0];
    },
    handleFileUpload(event) {
      this.thumbnailFile = event.target.files[0];
    },

    fetchBlogs(value) {
      this.currentPage = value;
      axios
        .get(
          `${process.env.VUE_APP_API}/blog-details/list/?page=${value}&Key=${this.userInfo.token_key}&page_size=${this.pageSize}&search=${this.searchvalue}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.bloglist = res.data.data.data;
            this.blogcount = res.data.total;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
            this.totalPages = res.data.total_page;
            this.current_page = res.data.current_page;
          }
        })
        .catch((error) => {
          console.error("Error fetching blogs:", error);
        });
    },
    // async searchUserValue() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/blog-details/list/?search=${this.searchvalue}&Key=${this.userInfo.token_key}`,
    //     )
    //     .then((res) => {
    //       if (res.data.data.status == 200) {
    //         this.bloglist = res.data.data.data;
    //         this.blogcount = res.data.total;
    //         setTimeout(() => {
    //           this.loading = false;
    //         }, 1000);
    //         this.totalPages = res.data.total_page;
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching blogs:", error);
    //     });
    // },
    categoryAdd(el) {
      this.categorySubmitting = true;
      let bodyVal = {
        name: el.target.elements.categorytitle.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/blog-category/post/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Category Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.categorySubmitting = false;
              this.is_CategoryPopup = false;
              this.categoryget();
            }, 3000);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 3000);
          }
        });
    },
    categoryget() {
      axios
        .get(
          `${process.env.VUE_APP_API}/blog-category/list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.data.data) {
            this.categories = res.data.data.data;
          }
        });
    },
    async createBlogs(e) {
      this.disable_submit = true;
      let token = this.userInfo.token_key;

      this.description = document.querySelector(".ql-editor").innerHTML;

      let urls = `${process.env.VUE_APP_API}/blog-details/post/?Key=${token}`;
      let HeaderVal = new FormData();

      if (e.target.elements.thumbnail.files.length > 0) {
        var thumbnailVal = e.target.elements.thumbnail.files[0];
        HeaderVal.append("thumbnail", thumbnailVal);
      }

      HeaderVal.append("title", e.target.elements.title.value);

      HeaderVal.append(
        "category_id",
        parseInt(e.target.elements.category.value),
      );

      // HeaderVal.append("description", this.description);
      HeaderVal.append("content", this.description);

      HeaderVal.append("published", e.target.elements.Published.checked);
      HeaderVal.append("bolger_id", this.userInfo.user.id);

      await axios
        .post(urls, HeaderVal, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {

          if (response.data.status == 200) {
            this.messages = {
              text: "Blog Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.blogRef.reset();
              // this.$router.push({
              //   name: "InstructorBlogsList",
              // });
              this.blogPopup = false;
              this.fetchBlogs(this.currentPage);

              this.disable_submit = false;
            }, 1500);
          } else {
            this.disable_submit = false;
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
